import { Component } from 'react';
import { Alert, Col, Offcanvas, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { t } from '../../../helpers/translation_helper';
import { toggleAIGenerationModal, setAIContent } from '../../../redux/slices/AIGenerationModalSlice';
import { GET, POST } from '../../../api';
import educoreAiVideo from '../../../assets/images/educore-ai.webm';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import AIActivityResources from './AIActivityResources';

class AIGenerationModal extends Component {

  state = {
    generating: false,
    generatedContent: '',
    prompt: '',
  }

  componentDidMount() {
    this.getStaticPrompt();
  }

  getStaticPrompt = async () => {
    try {
      const res = await GET('ai/get-static-prompt', {
        params: {
          aip_type: this.props.type,
        }
      });

      const prompt = res.data.prompt;

      this.setState({ prompt });
    } catch (err) {
      console.error(err);
    }
  }

  generateContent = async () => {
    this.setState({ generating: true, generatedContent: '' });
    try {
      const fData = new FormData();
      fData.append('prompt', this.state.prompt + (this.props.dynamicAIPrompt || ''));
      const res = await POST('ai/generate-content', fData);

      if (res.data.error) {
        this.setState({ generating: false });
        toast.error(res.data.error);
        return;
      }

      this.setState({
        generating: false,
        generatedContent: res.data?.content
      });
    } catch (err) {
      console.error(err);
      this.setState({ generating: false });
    }
  }

  searchContent = async (query) => {
    this.setState({ generating: true, generatedContent: '' });
    try {
      const res = await GET('ai/search-content', {
        params: {
          query: 'kids activity ideas videos',
        }
      });

      if (res.data.error) {
        this.setState({ generating: false });
        toast.error(res.data.error);
        return;
      }

      this.setState({
        generating: false,
        generatedContent: res.data?.content
      });
    } catch (err) {
      console.error(err);
      this.setState({ generating: false });
    }
  }

  render() {
    return (
      <Offcanvas backdropClassName="ai-generation-modal-backdrop" style={{ width: '50%', zIndex: 9999 }} placement={'end'} show={this.props.show} onHide={() => {
        this.props.toggleAIGenerationModal();
        this.setState({ generating: false });
      }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ display: 'flex', alignItems: 'center' }}>
            <small style={{
              backgroundColor: '#D23341',
              color: '#fff',
              padding: '2px 5px',
              borderRadius: '5px',
              fontSize: 14,
              fontWeight: '600',
              marginRight: 7,
            }}>{t('NEW')}</small>
            <svg className='me-1' width="38" height="38" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="3%" stopColor="#00c4cc" />
                  <stop offset="52%" stopColor="#5a32fa" />
                  <stop offset="100%" stopColor="#7d2ae8" />
                </linearGradient>
              </defs>
              <path
                fill="url(#gradient)"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.568 16.49c-1.808-.595-3.284-1.453-4.46-2.672-1.13-1.171-1.917-2.61-2.479-4.31-.575 1.75-1.39 3.204-2.548 4.375-1.176 1.19-2.639 2.019-4.395 2.599 1.802.588 3.275 1.435 4.448 2.642 1.139 1.172 1.928 2.615 2.49 4.329.576-1.75 1.391-3.202 2.548-4.37 1.177-1.19 2.64-2.015 4.396-2.593Zm-6.306 9.48a.657.657 0 0 1-.636.517.657.657 0 0 1-.643-.55c-1.067-5.2-3.357-7.717-8.69-8.784a.667.667 0 0 1 0-1.333c4.785-.982 7.228-3.12 8.418-7.612l.002-.01c.102-.385.195-.789.28-1.21a.657.657 0 0 1 .776-.486.663.663 0 0 1 .489.48c1.066 5.2 3.368 7.771 8.701 8.838a.667.667 0 0 1 0 1.333c-5.2 1.067-7.63 3.484-8.697 8.818Zm9.892-17.553c.11-.07.224-.132.343-.188a3.62 3.62 0 0 1 .925-.292.2.2 0 0 0 .2-.203c0-.113-.083-.187-.194-.208l-.031-.008a2.032 2.032 0 0 1-.053-.013 4.83 4.83 0 0 1-.829-.297 3.963 3.963 0 0 1-.363-.194 3.237 3.237 0 0 1-1.27-1.39 3.618 3.618 0 0 1-.273-.825l-.005-.026a4.401 4.401 0 0 1-.014-.075.204.204 0 0 0-.204-.204v.004c-.112 0-.187.083-.208.194l-.007.03a1.733 1.733 0 0 1-.014.054 4.828 4.828 0 0 1-.295.827c-.06.128-.125.25-.195.365a3.237 3.237 0 0 1-1.391 1.27 3.621 3.621 0 0 1-.926.292.204.204 0 0 0-.204.204h.005c0 .112.083.187.193.208l.031.007.043.01.01.003c.3.079.575.178.828.296.127.06.249.125.365.195a3.237 3.237 0 0 1 1.27 1.391 3.618 3.618 0 0 1 .272.824l.005.026.015.076a.204.204 0 0 0 .203.203v-.004c.113 0 .187-.083.208-.193l.008-.031a2.254 2.254 0 0 1 .013-.054c.078-.298.177-.574.296-.827.06-.127.124-.249.194-.365a3.239 3.239 0 0 1 1.05-1.082ZM9.53 25.917c.076-.047.155-.089.239-.128a3.245 3.245 0 0 1 .79-.254.29.29 0 1 0 0-.58 6.041 6.041 0 0 1-.766-.288 3.787 3.787 0 0 1-.26-.135 2.605 2.605 0 0 1-1.097-1.163 3.246 3.246 0 0 1-.253-.79.29.29 0 0 0-.581 0 5.22 5.22 0 0 1-.288.766 3.76 3.76 0 0 1-.135.258 2.604 2.604 0 0 1-1.163 1.098 3.239 3.239 0 0 1-.79.253.29.29 0 0 0 0 .581l.124.039c.231.074.445.156.641.25.09.042.177.087.26.134a2.604 2.604 0 0 1 1.097 1.163 3.242 3.242 0 0 1 .254.79.29.29 0 0 0 .58 0l.04-.123c.073-.232.156-.446.249-.642.042-.09.087-.177.135-.26.236-.412.534-.734.924-.97ZM11.115 8.47c-1.254.472-2.1 1.207-2.586 2.454a5.944 5.944 0 0 0-.227.722 8.187 8.187 0 0 0-.168.888.287.287 0 0 1-.266.266.287.287 0 0 1-.267-.266 9.144 9.144 0 0 0-.168-.888 5.944 5.944 0 0 0-.227-.722C6.72 9.677 5.874 8.942 4.62 8.47a8.384 8.384 0 0 0-.813-.257 12.674 12.674 0 0 0-.873-.195.287.287 0 0 1-.267-.267c0-.133.134-.267.267-.267l.104-.01c.284-.027.552-.064.804-.111.29-.055.561-.123.812-.205C5.86 6.764 6.62 6.044 7.089 4.934a5.84 5.84 0 0 0 .122-.314c.088-.247.164-.512.23-.796a9.878 9.878 0 0 0 .16-.89c0-.134.133-.267.267-.267.133 0 .266.133.266.267a10.962 10.962 0 0 0 .16.89c.066.284.142.549.23.796.038.108.079.212.122.314.468 1.11 1.228 1.83 2.435 2.224.251.082.521.15.812.205a9.128 9.128 0 0 0 .908.121c.133 0 .267.134.267.267a.287.287 0 0 1-.267.267 13.245 13.245 0 0 0-.873.195c-.288.076-.56.161-.813.257Z"
              />
            </svg>
            <h3
              style={{
                background: 'linear-gradient(90deg,#6441C7 3%, #00C0FE 52%, #FF00C6 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                color: 'transparent',
                fontWeight: 700
              }}
              className='m-0'>{t('Educore AI')}</h3>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='pt-0'>
          {this.props.centerData.subscriptions.includes('ai') ?
            <>
              <Alert style={{ fontSize: 13 }} className='mb-3' variant='light'>
                {t('This feature is powered by Educore AI, so mistakes are possible. Review the generated content carefully before using it.')}
              </Alert>
              <div style={{
                height: 'calc(100vh - 210px)',
                overflowY: 'auto',
                overflowX: 'hidden',
                borderRadius: 7,
                marginBottom: 15,
              }}>
                {this.state.generating ?
                  <div className='d-flex justify-content-center align-items-center' style={{ height: '100%' }}>
                    <video
                      src={educoreAiVideo}
                      autoPlay
                      loop
                      muted
                      style={{ width: 130, height: 130, marginBottom: 15 }}
                    />
                  </div>
                  :
                  <div>
                    {this.state.generatedContent && Object.entries(this.state.generatedContent).map(([key, value]) => {
                      return (<div key={key} style={{
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#f5f5f5',
                        padding: '5px 10px 10px',
                        marginBottom: 10,
                        borderRadius: 7,
                      }}>
                        <Row>
                          <Col md={9}><strong>{key}</strong></Col>
                          <Col md={3} className='text-end'>
                            <button style={{
                              border: 'none',
                              borderRadius: 5,
                              fontSize: 12,
                              backgroundColor: '#47BCE8',
                              color: '#fff',
                            }}
                              onClick={() => {
                                if (this.props.type === 'activity' && key == 'Resources') {
                                  this.props.setAIResources(value);
                                } else {
                                  this.props.setAIContent({
                                    key: value.key,
                                    value: value.value
                                  });
                                }
                                toast.success(t('Content copied to associated field successfully!'));
                              }}
                              title={t('Copy to associated field')}><FontAwesomeIcon className='me-1' icon={faCopy} />{t('Copy')}</button>
                          </Col>
                          <Col md={12}>
                            {this.props.type === 'activity' && key == 'Resources' ?
                              <AIActivityResources resources={value} />
                              :
                              <div dangerouslySetInnerHTML={{ __html: value.value }} />
                            }
                          </Col>
                        </Row>
                      </div>)
                    })}
                  </div>
                }
              </div>
              <div className='d-flex justify-content-end'>
                <button style={{
                  color: '#fff',
                  background: 'linear-gradient(90deg, #00c4cc 13%,#5a32fa 52%, #7d2ae8 70%, #FF00C6 100%)',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '7px 10px',
                  borderRadius: 7,
                  opacity: this.state.generating ? 0.7 : 1,
                }} onClick={this.generateContent} disabled={this.state.generating}>
                  <svg style={{ marginRight: 1 }} width="25" height="25" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23.568 16.49c-1.808-.595-3.284-1.453-4.46-2.672-1.13-1.171-1.917-2.61-2.479-4.31-.575 1.75-1.39 3.204-2.548 4.375-1.176 1.19-2.639 2.019-4.395 2.599 1.802.588 3.275 1.435 4.448 2.642 1.139 1.172 1.928 2.615 2.49 4.329.576-1.75 1.391-3.202 2.548-4.37 1.177-1.19 2.64-2.015 4.396-2.593Zm-6.306 9.48a.657.657 0 0 1-.636.517.657.657 0 0 1-.643-.55c-1.067-5.2-3.357-7.717-8.69-8.784a.667.667 0 0 1 0-1.333c4.785-.982 7.228-3.12 8.418-7.612l.002-.01c.102-.385.195-.789.28-1.21a.657.657 0 0 1 .776-.486.663.663 0 0 1 .489.48c1.066 5.2 3.368 7.771 8.701 8.838a.667.667 0 0 1 0 1.333c-5.2 1.067-7.63 3.484-8.697 8.818Zm9.892-17.553c.11-.07.224-.132.343-.188a3.62 3.62 0 0 1 .925-.292.2.2 0 0 0 .2-.203c0-.113-.083-.187-.194-.208l-.031-.008a2.032 2.032 0 0 1-.053-.013 4.83 4.83 0 0 1-.829-.297 3.963 3.963 0 0 1-.363-.194 3.237 3.237 0 0 1-1.27-1.39 3.618 3.618 0 0 1-.273-.825l-.005-.026a4.401 4.401 0 0 1-.014-.075.204.204 0 0 0-.204-.204v.004c-.112 0-.187.083-.208.194l-.007.03a1.733 1.733 0 0 1-.014.054 4.828 4.828 0 0 1-.295.827c-.06.128-.125.25-.195.365a3.237 3.237 0 0 1-1.391 1.27 3.621 3.621 0 0 1-.926.292.204.204 0 0 0-.204.204h.005c0 .112.083.187.193.208l.031.007.043.01.01.003c.3.079.575.178.828.296.127.06.249.125.365.195a3.237 3.237 0 0 1 1.27 1.391 3.618 3.618 0 0 1 .272.824l.005.026.015.076a.204.204 0 0 0 .203.203v-.004c.113 0 .187-.083.208-.193l.008-.031a2.254 2.254 0 0 1 .013-.054c.078-.298.177-.574.296-.827.06-.127.124-.249.194-.365a3.239 3.239 0 0 1 1.05-1.082ZM9.53 25.917c.076-.047.155-.089.239-.128a3.245 3.245 0 0 1 .79-.254.29.29 0 1 0 0-.58 6.041 6.041 0 0 1-.766-.288 3.787 3.787 0 0 1-.26-.135 2.605 2.605 0 0 1-1.097-1.163 3.246 3.246 0 0 1-.253-.79.29.29 0 0 0-.581 0 5.22 5.22 0 0 1-.288.766 3.76 3.76 0 0 1-.135.258 2.604 2.604 0 0 1-1.163 1.098 3.239 3.239 0 0 1-.79.253.29.29 0 0 0 0 .581l.124.039c.231.074.445.156.641.25.09.042.177.087.26.134a2.604 2.604 0 0 1 1.097 1.163 3.242 3.242 0 0 1 .254.79.29.29 0 0 0 .58 0l.04-.123c.073-.232.156-.446.249-.642.042-.09.087-.177.135-.26.236-.412.534-.734.924-.97ZM11.115 8.47c-1.254.472-2.1 1.207-2.586 2.454a5.944 5.944 0 0 0-.227.722 8.187 8.187 0 0 0-.168.888.287.287 0 0 1-.266.266.287.287 0 0 1-.267-.266 9.144 9.144 0 0 0-.168-.888 5.944 5.944 0 0 0-.227-.722C6.72 9.677 5.874 8.942 4.62 8.47a8.384 8.384 0 0 0-.813-.257 12.674 12.674 0 0 0-.873-.195.287.287 0 0 1-.267-.267c0-.133.134-.267.267-.267l.104-.01c.284-.027.552-.064.804-.111.29-.055.561-.123.812-.205C5.86 6.764 6.62 6.044 7.089 4.934a5.84 5.84 0 0 0 .122-.314c.088-.247.164-.512.23-.796a9.878 9.878 0 0 0 .16-.89c0-.134.133-.267.267-.267.133 0 .266.133.266.267a10.962 10.962 0 0 0 .16.89c.066.284.142.549.23.796.038.108.079.212.122.314.468 1.11 1.228 1.83 2.435 2.224.251.082.521.15.812.205a9.128 9.128 0 0 0 .908.121c.133 0 .267.134.267.267a.287.287 0 0 1-.267.267 13.245 13.245 0 0 0-.873.195c-.288.076-.56.161-.813.257Z"
                    />
                  </svg>
                  {t('Generate Content')}
                </button>
              </div>
            </>
            :
            <div style={{
              height: 'calc(100vh - 87px)',
              overflowY: 'auto',
              backgroundColor: '#FCFCFD',
              borderRadius: 7,
              border: '1px solid #E9ECEF',
              padding: 15,
            }} className='d-flex flex-column align-items-center justify-content-center'>
              <p style={{ fontSize: "1.1em", marginTop: "20px" }}>
                <strong>🚀 Modernize Your School Operations with Educore AI</strong>
              </p>
              <p className='text-center'>
                Say goodbye to manual processes and fragmented systems. Educore AI is your all-in-one School Management System designed to simplify administration, streamline communication, and provide real-time insights across academics, finance, attendance, and more.
              </p>
              <p className='text-center'>
                ✨ Whether you're managing a small private school or a large institution - Educore AI adapts to your unique needs with powerful, intelligent automation.
              </p>
              <p style={{ fontWeight: "bold" }}>
                🎓 Subscribe now and bring smart efficiency to your school operations!
              </p>
            </div>
          }
        </Offcanvas.Body>
      </Offcanvas>
    );
  }
}

const mapStateToProps = (state) => ({
  centerData: state.auth.authData.centerData,
  show: state.AIGenerationModal.show,
  dynamicAIPrompt: state.AIGenerationModal.dynamicAIPrompt,
});

const mapDispatchToProps = () => ({
  toggleAIGenerationModal,
  setAIContent,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps()
)(AIGenerationModal);